export function TermsOfUsePage() {
    return (
        <div className="container py-5">
            <div className="row justify-content-center">
                <div className="col-lg-8">
                    <h1 className="display-5 fw-bold mb-4">Terms of Use</h1>
                    <p className="text-muted mb-5">Last updated: {new Date().toLocaleDateString()}</p>

                    <div className="terms-content">
                        <section className="mb-5">
                            <h2 className="h4 fw-semibold mb-3">1. Acceptance of Terms</h2>
                            <p>
                                By accessing and using the Arcane ECM (Enterprise Content Management) service, 
                                you accept and agree to be bound by the terms and provision of this agreement. 
                                If you do not agree to these terms, you should not use this service.
                            </p>
                        </section>

                        <section className="mb-5">
                            <h2 className="h4 fw-semibold mb-3">2. Service Description</h2>
                            <p>
                                Arcane ECM provides enterprise content management services that allow users to:
                            </p>
                            <ul>
                                <li>Store files in various cloud storage providers</li>
                                <li>Manage content through Salesforce integration</li>
                                <li>Access analytics and reporting features</li>
                                <li>Configure data sources and targets</li>
                            </ul>
                        </section>

                        <section className="mb-5">
                            <h2 className="h4 fw-semibold mb-3">3. User Accounts</h2>
                            <p>
                                To access certain features of the service, you must create an account. You are 
                                responsible for:
                            </p>
                            <ul>
                                <li>Maintaining the confidentiality of your account credentials</li>
                                <li>All activities that occur under your account</li>
                                <li>Notifying us immediately of any unauthorized use</li>
                                <li>Providing accurate and current information</li>
                            </ul>
                        </section>

                        <section className="mb-5">
                            <h2 className="h4 fw-semibold mb-3">4. Acceptable Use</h2>
                            <p>You agree not to use the service to:</p>
                            <ul>
                                <li>Violate any applicable laws or regulations</li>
                                <li>Infringe on intellectual property rights</li>
                                <li>Upload malicious content or malware</li>
                                <li>Attempt to gain unauthorized access to our systems</li>
                                <li>Interfere with the service's operation</li>
                                <li>Share account credentials with unauthorized users</li>
                            </ul>
                        </section>

                        <section className="mb-5">
                            <h2 className="h4 fw-semibold mb-3">5. Data and Content</h2>
                            <p>
                                You retain ownership of your data and content. By using our service, you grant us 
                                a limited license to:
                            </p>
                            <ul>
                                <li>Store and process your data as necessary to provide the service</li>
                                <li>Create backups for data protection purposes</li>
                                <li>Generate analytics and usage statistics (anonymized)</li>
                            </ul>
                            <p>
                                We will not access, use, or disclose your content except as necessary to provide 
                                the service or as required by law.
                            </p>
                        </section>

                        <section className="mb-5">
                            <h2 className="h4 fw-semibold mb-3">6. Service Availability</h2>
                            <p>
                                While we strive to maintain high availability, we do not guarantee uninterrupted 
                                service. We may temporarily suspend service for maintenance, updates, or other 
                                operational reasons with reasonable notice when possible.
                            </p>
                        </section>

                        <section className="mb-5">
                            <h2 className="h4 fw-semibold mb-3">7. Limitation of Liability</h2>
                            <p>
                                To the maximum extent permitted by law, Arcane Scale LLC shall not be liable for 
                                any indirect, incidental, special, or consequential damages arising from your use 
                                of the service. Our total liability shall not exceed the amount paid by you for 
                                the service in the 12 months preceding the claim.
                            </p>
                        </section>

                        <section className="mb-5">
                            <h2 className="h4 fw-semibold mb-3">8. Indemnification</h2>
                            <p>
                                You agree to indemnify and hold harmless Arcane Scale LLC from any claims, 
                                damages, or expenses arising from your use of the service, violation of these 
                                terms, or infringement of any third-party rights.
                            </p>
                        </section>

                        <section className="mb-5">
                            <h2 className="h4 fw-semibold mb-3">9. Termination</h2>
                            <p>
                                We may terminate or suspend your account immediately, without prior notice, for 
                                any breach of these terms. You may terminate your account at any time by 
                                contacting us. Upon termination, your right to use the service will cease.
                            </p>
                        </section>

                        <section className="mb-5">
                            <h2 className="h4 fw-semibold mb-3">10. Changes to Terms</h2>
                            <p>
                                We reserve the right to modify these terms at any time. We will notify users of 
                                material changes via email or through the service. Continued use of the service 
                                after changes constitutes acceptance of the new terms.
                            </p>
                        </section>

                        <section className="mb-5">
                            <h2 className="h4 fw-semibold mb-3">11. Governing Law</h2>
                            <p>
                                These terms are governed by and construed in accordance with the laws of the 
                                state where Arcane Scale LLC is incorporated, without regard to conflict of 
                                law principles.
                            </p>
                        </section>

                        <section className="mb-5">
                            <h2 className="h4 fw-semibold mb-3">12. Contact Information</h2>
                            <p>
                                If you have any questions about these terms, please contact us at:
                            </p>
                            <address>
                                <strong>Arcane Scale LLC</strong><br />
                                Email: info@arcanescale.com<br />
                                Website: <a href="https://www.arcanescale.com" target="_blank" rel="noopener noreferrer">
                                    www.arcanescale.com
                                </a>
                            </address>
                        </section>
                    </div>
                </div>
            </div>
        </div>
    );
}